import { ConnectedProps, connect } from 'react-redux'
import { Modify } from '@teinor/erp'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import ITHeaderText, { ITHeaderTextCustomer } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { returnClassOfSpanTemplate } from '../../../../../../../../../utils/globals/tailwind'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import { ComponentTabObject } from '../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../../utils/reducers/company/employees'
import { WorkingCenterPayload } from '../../../../../../../../../utils/reducers/company/workingCenters'
import { InputWithLabelMargin } from '../../../../../../../../../forms/Input'
import { SellDeliveryNoteModelType } from '@teinor/erp/types/company/order/sell/sellDeliveryNote'
import AppStyleDecider from '../../../../../../../../../baseComponents/AppsStyleDecider'
import InputTableTopHeader from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'

type SellDeliveryNoteRefundITHeaderProps = Modify<InputTableLeftColumnCompleteRequiredProps, ReduxSellDeliveryNoteRefundITHeader & {}>

const SellDeliveryNoteRefundITHeader: React.FC<SellDeliveryNoteRefundITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={SellDeliveryNoteRefundITHeaderDefault} NewComponent={SellDeliveryNoteRefundITHeaderNew} {...rest} />
}

const SellDeliveryNoteRefundITHeaderDefault: React.FC<SellDeliveryNoteRefundITHeaderProps> = ({ workingCenters, ...rest }) => {
    const {t} = useTwinTranslation()
    const tabs: ComponentTabObject = {
        'main': {
            component: SellDeliveryNoteRefundITHeaderMain,
            text: t('dataRefund', 'Datos de la devolución'),
            extraProps: { workingCenters }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const SellDeliveryNoteRefundITHeaderNew: React.FC<SellDeliveryNoteRefundITHeaderProps> = ({ workingCenters, headerData, getCompleteData, setCompleteData, updateDataURL }) => {
    const { t } = useTwinTranslation()
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData, updateDataURL })
    const sections: FormRender<SellDeliveryNoteModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'CustomerId',
                    component: 'Custom',
                    render: () => <ITHeaderTextCustomer label={t('customer', 'Cliente')} headerData={headerData || {}} />
                },
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={(props.onChange)} defaultValue={headerData?.custom_name} className='custom_name_input_field' />
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('full_assigned_number', 'Nº de Devolución')} value={headerData?.full_assigned_number || ''} />,
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('workingCenter', 'Centro de trabajo')} value={workingCenters?.[headerData?.WorkingCenterId]?.name || ''} />,
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie || ''} />,
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('invoicedBy', 'Facturado por')} value={workingCenters?.[headerData?.BillingWorkingCenterId]?.name || ''} />,
                },
            ]
        }
    ]
    return (
        <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
    )
}

interface SellDeliveryNoteRefundITHeaderMainProps extends InputTableLeftTabsProps {
    workingCenters: WorkingCenterPayload
    headerData: TwinDictionary
}

const SellDeliveryNoteRefundITHeaderMain: React.FC<SellDeliveryNoteRefundITHeaderMainProps> = ({ workingCenters,  handleChange, headerData}) => {
    const { t } = useTwinTranslation()
    const sections: FormRender<SellDeliveryNoteModelType> = [
        {
            cols: 5,
            elements: [
                {
                    name: 'CustomerId',
                    component: 'Custom',
                    render: () => <ITHeaderTextCustomer label={t('customer', 'Cliente')} headerData={headerData} className={returnClassOfSpanTemplate(5)} />
                },
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={(props.onChange)} defaultValue={headerData?.custom_name} className={returnClassOfSpanTemplate(5)}/>
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('full_assigned_number', 'Nº de Devolución')} value={headerData?.full_assigned_number || ''} className={returnClassOfSpanTemplate(3)} />,
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('workingCenter', 'Centro de trabajo')} value={workingCenters?.[headerData?.WorkingCenterId]?.name || ''} className={returnClassOfSpanTemplate(3)} />,
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie || ''} className={returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('invoicedBy', 'Facturado por')} value={workingCenters?.[headerData?.BillingWorkingCenterId]?.name || ''} className={returnClassOfSpanTemplate(3)} />,
                },
            ]
        }
    ]
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData}/>
    )
}


const SellDeliveryNoteRefundITHeaderDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

export type ReduxSellDeliveryNoteRefundITHeader = ConnectedProps<typeof sellDeliveryNoteRefundITHeaderConnect>
const mapSellDeliveryNoteRefundITHeaderConnector = (state: AllReduxPayloads) => ({ employees: state.employees, workingCenters: state.workingCenters})
const sellDeliveryNoteRefundITHeaderConnect = connect(mapSellDeliveryNoteRefundITHeaderConnector, SellDeliveryNoteRefundITHeaderDispatch)
const SellDeliveryNoteRefundITHeaderConnectLoading = withLoading(SellDeliveryNoteRefundITHeader, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const SellDeliveryNoteRefundITHeaderConnect = sellDeliveryNoteRefundITHeaderConnect(SellDeliveryNoteRefundITHeaderConnectLoading)

export default SellDeliveryNoteRefundITHeaderConnect